module.exports = __webpack_public_path__ + "static/media/wine-cheese.f9f498e3.jpg";